import React, {Component} from "react";
import PropTypes from "prop-types";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Box, Column, Columns, Title } from "@allxsmith/bestax-bulma";
import AvailablePanel from "./AvailablePanel";
import RentalsPanel from "./RentalsPanel";
import VehicleFinder from "./VehicleFinder";

// export default function VehicleFinderSection(props) {
//   const dispatch = useDispatch();
//   let vehicleTypes = useSelector(getVehicleTypesData);
//   let dataFresh = useSelector(getDataFresh);
//   const [searchText, setSearchText] = useState("");
//   const [currentSearch, setCurrentSearch] = useState("");
//   const [filters, setFilters] = useState({});
//
// }
export default class VehicleFinderSection extends Component {

  static propTypes = {
    endpoint: PropTypes.string.isRequired
  };
  state = {
    vehicle: this.props.vehicle,
    searchData: [],
    isLoading: false,
    type: "",
    availableVehicles: []
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSearch = e => {};

  handleVehicleSelect = e => {
    this.props.selectVehicle(e[0]);
    this.typeahead.getInstance().clear();
    // this.props.vehicleUpdate(e[0]);
  };

  updateAvailableVehicles = vehicles => {
    this.setState({ availableVehicles: vehicles });
  };

  render() {
    return (
      <Box>
        <Columns isMultiline>
          <Column size="one-fifth">
            <Title>Vehicle Finder</Title>
            <VehicleFinder
              vehicle={{}}
              endpoint={this.props.endpoint}
              updateAvailableVehicles={this.updateAvailableVehicles}
              selectVehicle={this.props.selectVehicle}
              startDate={this.props.startDate}
              finishDate={this.props.finishDate}
            />
          </Column>
          <Column>
            <Title>Available</Title>
            <AvailablePanel
              vehicles={this.state.availableVehicles}
              selectVehicle={this.props.selectVehicle}
            />
          </Column>
          <Column>
            <Title>Other Rentals</Title>
            <RentalsPanel
              onHireDate={this.props.onHireDate}
              finishDate={this.props.finishDate}
              endpoint={`${this.props.endpoint}rentals`}
            />
          </Column>
        </Columns>
      </Box>
    );
  }
}
